module.exports = __webpack_public_path__ + "static/media/Huawei3.5b028a02.gif";